import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../styles/optionsModel.css";
import UserContext from "../../UserContext";

function PostOptions(props) {
  const { mode } = React.useContext(UserContext);
  const [dark, setDark] = React.useState(false);

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <Modal {...props} centered className={dark && "special_modal"}>
      <Modal.Body className="text-center p-0">
        <Link to="#" className="font-bold option-links text-danger">
          <div className="text-container">Report</div>
        </Link>
        <Link to="#" className="font-bold option-links text-danger">
          <div
            className="text-container"
            onClick={() =>
              props.hommie
                ? props.removehommie(props.data?.author?._id)
                : props.addhommie(props.data?.author?._id)
            }
          >
            {props.hommie ? "Remove from homies" : "Add to homies"}
          </div>
        </Link>
        <Link to="#" className="font-bold option-links text-secondary">
          <div className="text-container">Save as favorite</div>
        </Link>
        <Link to="#" className="font-bold option-links text-secondary">
          <div className="text-container">Share to...</div>
        </Link>
        <div
          to="#"
          className="font-bold option-links text-secondary text-container"
          onClick={() => {
            navigator.clipboard.writeText(props.toCopyUrl).then(props.onHide);
          }}
        >
          Copy link
        </div>
        <div
          onClick={props.onHide}
          className="font-bold option-links text-secondary text-container"
        >
          Cancel
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PostOptions;
